import React from "react";
import { Badge, colors } from "../design/badge";
import { EventType } from "@visitproof/types";

interface EventStatusBadgeProps {
  type: EventType;
  severity?: string;
}

const EventStatusBadge: React.FC<EventStatusBadgeProps> = ({ type, severity }) => {
  let color;
  let title;

  // Determine color and title based on event type
  switch (type) {
    // Visit-related events
    case "supervisor_started":
      color = "blue"; // Represents initiation, a neutral color indicating action
      title = "Supervisor Started";
      break;
    case "supervisor_arrived":
      color = "green"; // Indicates success or completion of arrival
      title = "Supervisor Arrived";
      break;
    case "supervisor_enroute":
      color = "orange"; // Suggests progress or movement
      title = "Supervisor Enroute";
      break;
    case "supervisor_no_show":
      color = "red"; // Signifies an alert or problem
      title = "Supervisor No Show";
      break;
    case "supervisor_ended":
      color = "purple"; // Represents closure or completion
      title = "Completed"
      break
    // Event types
    case "observation":
      color = "blue"; // Neutral observation color
      title = "Observation";
      break;
    case "interaction":
      color = "green"; // Positive interaction color
      title = "Interaction";
      break;
    case "incident":
      color = "red"; // Incident/alert color
      title = "Incident";
      break;
    case "intervention":
      color = "purple"; // Staff intervention
      title = "Intervention";
      break;
    case "phone_call":
      color = "teal"; // Phone contact
      title = "Phone Call";
      break;
    case "party_arrived":
      color = "sky"; // Arrival timestamp
      title = "Arrival";
      break;
    case "handoff_note":
      color = "violet"; // Handoff / intake info
      title = "Handoff Notes";
      break;
    default:
      color = "yellow"; // Default color if type is unknown
      title = type;
  }

  // Override color based on severity if provided
  if (severity) {
    const severityLower = severity.toLowerCase();
    if (severityLower.includes("high") || severityLower.includes("critical")) {
      color = "red";
    } else if (severityLower.includes("medium") || severityLower.includes("moderate")) {
      color = "orange";
    } else if (severityLower.includes("low") || severityLower.includes("minor")) {
      color = "yellow";
    }
  }

  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default EventStatusBadge; 